import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Youtube, Twitter, Instagram, MessageCircle, Mail, Sparkles } from 'lucide-react';

const Footer = () => {
  const socialIcons = [
    { name: 'Facebook', icon: Facebook, href: '#' },
    { name: 'YouTube', icon: Youtube, href: '#' },
    { name: 'X (Twitter)', icon: Twitter, href: '#' },
    { name: 'Instagram', icon: Instagram, href: '#' },
    { name: 'WhatsApp', icon: MessageCircle, href: '#' },
    { name: 'Gmail', icon: Mail, href: '#' },
  ];

  const resources = [
    { name: 'Sacred Wisdom Institute', desc: 'Advanced spiritual education' },
    { name: 'Healing Arts Academy', desc: 'Energy healing certification' },
    { name: 'Meditation Masters', desc: 'Global meditation community' },
    { name: 'Spiritual Library Online', desc: 'Digital sacred texts' },
    { name: 'Consciousness Research Center', desc: 'Scientific spirituality' },
  ];

  return (
    <footer className="py-16" style={{
      background: 'linear-gradient(180deg, #0d0618 0%, #080410 100%)'
    }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Social Links */}
        <div className="flex justify-center gap-4 mb-12">
          {socialIcons.map((social) => (
            <a
              key={social.name}
              href={social.href}
              className="w-12 h-12 rounded-full bg-[#2a2a4a] flex items-center justify-center text-gray-400 hover:bg-pink-600 hover:text-white transition-all duration-300"
              title={social.name}
            >
              <social.icon className="w-5 h-5" />
            </a>
          ))}
        </div>

        {/* Resources Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-12">
          {resources.map((resource) => (
            <div 
              key={resource.name} 
              className="bg-[#1a1a2e]/50 rounded-xl p-4 text-center transition-all duration-300 hover:bg-[#2a2a3e]/50 cursor-pointer"
            >
              <h4 className="text-white font-medium text-sm mb-1">{resource.name}</h4>
              <p className="text-gray-500 text-xs">{resource.desc}</p>
            </div>
          ))}
        </div>

        {/* Copyright */}
        <div className="text-center border-t border-gray-700/30 pt-8">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Sparkles className="w-5 h-5 text-pink-400" />
            <span className="text-white font-semibold">Dr. Nawwaf Alshibli</span>
          </div>
          <p className="text-gray-500 text-sm mb-6">
            &copy; 2025 Dr. Nawwaf Alshibli. All rights reserved.
          </p>

          {/* Company Info - Featured Frame */}
          <div className="mb-10">
            <div className="max-w-4xl mx-auto rounded-2xl border border-pink-500/40 bg-gradient-to-br from-pink-500/10 via-purple-500/8 to-transparent p-8 relative overflow-hidden" style={{ boxShadow: '0 0 20px rgba(236,72,153,0.25), 0 0 60px rgba(236,72,153,0.15), 0 0 120px rgba(168,85,247,0.1), inset 0 0 30px rgba(236,72,153,0.05), inset 0 1px 0 rgba(255,255,255,0.08)' }}>
              <div className="absolute -top-16 -left-16 w-48 h-48 bg-pink-500/20 rounded-full blur-3xl" />
              <div className="absolute -bottom-16 -right-16 w-48 h-48 bg-purple-500/20 rounded-full blur-3xl" />
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-px bg-gradient-to-r from-transparent via-pink-400/60 to-transparent" />
              <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-3/4 h-px bg-gradient-to-r from-transparent via-purple-400/60 to-transparent" />
              <div className="relative z-10">
                <div className="text-center mb-8">
                  <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 mb-1">Inner Bridge</h3>
                  <p className="text-gray-300 text-sm tracking-widest uppercase">The Quantum Spiritual Academy</p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div className="text-center md:text-left space-y-3 border-b md:border-b-0 md:border-r border-white/5 pb-6 md:pb-0 md:pr-8">
                    <p className="text-white font-bold text-lg">The Inner Bridge</p>
                    <p className="text-gray-300 text-sm">Innovation Lifestyle Consultancy L.L.C-FZ</p>
                    <div className="flex flex-col gap-1 mt-3">
                      <div className="flex items-center gap-2 justify-center md:justify-start">
                        <span className="text-gray-500 text-xs min-w-[130px]">License Number:</span>
                        <span className="text-gray-300 text-xs font-mono">2646553.01</span>
                      </div>
                      <div className="flex items-center gap-2 justify-center md:justify-start">
                        <span className="text-gray-500 text-xs min-w-[130px]">Formation Number:</span>
                        <span className="text-gray-300 text-xs font-mono">2646553</span>
                      </div>
                    </div>
                    <p className="text-gray-500 text-xs leading-relaxed mt-3">Meydan Grandstand, 6th Floor, Meydan Road, Nad Al Sheba, Dubai, U.A.E.</p>
                  </div>
                  <div className="text-center md:text-right space-y-3 md:pl-8" dir="rtl">
                    <p className="text-white font-bold text-lg">The Inner Bridge شركة</p>
                    <p className="text-gray-300 text-sm">Innovation Lifestyle Consultancy L.L.C-FZ</p>
                    <div className="flex flex-col gap-1 mt-3">
                      <div className="flex items-center gap-2 justify-center md:justify-start">
                        <span className="text-gray-500 text-xs min-w-[100px]">رقم الرخصة:</span>
                        <span className="text-gray-300 text-xs font-mono" dir="ltr">2646553.01</span>
                      </div>
                      <div className="flex items-center gap-2 justify-center md:justify-start">
                        <span className="text-gray-500 text-xs min-w-[100px]">رقم التأسيس:</span>
                        <span className="text-gray-300 text-xs font-mono" dir="ltr">2646553</span>
                      </div>
                    </div>
                    <p className="text-gray-500 text-xs leading-relaxed mt-3">ميدان جراند ستاند، الطابق السادس، شارع الميدان، ند الشبا، مدينة دبي، الإمارات العربية المتحدة</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="text-center" dir="rtl">
            <p className="text-gray-300 text-sm mb-1">للتواصل والاستفسار</p>
            <p className="text-gray-400 text-sm mb-1">مدير قسم البرمجة والذكاء الاصطناعي</p>
            <p className="text-white font-semibold text-sm mb-2">كنان واكد</p>
            <a
              href="https://wa.me/963988242654"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-green-400 hover:text-green-300 transition-colors duration-200"
              data-testid="footer-whatsapp-link"
            >
              <MessageCircle className="w-5 h-5" />
              <span dir="ltr" className="font-medium">+963 988 242 654</span>
            </a>
          </div>

          {/* Customer Service Numbers */}
          <div className="mt-8 text-center" dir="rtl">
            <p className="text-gray-300 font-semibold text-sm mb-4">أرقام خدمة العملاء - واتس آب</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-2xl mx-auto">
              <a href="https://wa.me/17808627900" target="_blank" rel="noopener noreferrer" className="bg-[#1a1a2e]/50 rounded-xl p-3 hover:bg-green-500/10 border border-gray-700/30 hover:border-green-500/30 transition-all" data-testid="footer-wa-americas">
                <p className="text-gray-400 text-xs mb-1">الأمريكيتين</p>
                <p dir="ltr" className="text-green-400 font-medium text-sm">+1 780 862 7900</p>
              </a>
              <a href="https://wa.me/33660716479" target="_blank" rel="noopener noreferrer" className="bg-[#1a1a2e]/50 rounded-xl p-3 hover:bg-green-500/10 border border-gray-700/30 hover:border-green-500/30 transition-all" data-testid="footer-wa-europe">
                <p className="text-gray-400 text-xs mb-1">أوروبا</p>
                <p dir="ltr" className="text-green-400 font-medium text-sm">+33 660 716 479</p>
              </a>
              <a href="https://wa.me/963933492642" target="_blank" rel="noopener noreferrer" className="bg-[#1a1a2e]/50 rounded-xl p-3 hover:bg-green-500/10 border border-gray-700/30 hover:border-green-500/30 transition-all" data-testid="footer-wa-damascus">
                <p className="text-gray-400 text-xs mb-1">دمشق</p>
                <p dir="ltr" className="text-green-400 font-medium text-sm">+963 933 492 642</p>
              </a>
              <a href="https://wa.me/966558604875" target="_blank" rel="noopener noreferrer" className="bg-[#1a1a2e]/50 rounded-xl p-3 hover:bg-green-500/10 border border-gray-700/30 hover:border-green-500/30 transition-all" data-testid="footer-wa-gulf">
                <p className="text-gray-400 text-xs mb-1">دول الخليج</p>
                <p dir="ltr" className="text-green-400 font-medium text-sm">+966 558 604 875</p>
              </a>
            </div>
          </div>

          {/* Legal Links */}
          <div className="flex flex-wrap justify-center gap-4 mt-8 text-xs text-gray-500">
            <Link to="/privacy-policy" className="hover:text-pink-400 transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
            <span className="text-gray-700">|</span>
            <Link to="/terms-of-service" className="hover:text-pink-400 transition-colors" data-testid="footer-terms-link">Terms of Service</Link>
            <span className="text-gray-700">|</span>
            <Link to="/cookie-policy" className="hover:text-pink-400 transition-colors" data-testid="footer-cookie-link">Cookie Policy</Link>
            <span className="text-gray-700">|</span>
            <Link to="/refund-policy" className="hover:text-pink-400 transition-colors" data-testid="footer-refund-link">Refund Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
